// --- SaniQ ---
import config from "config";

/**
 * Get the currently active tenant based on the URL
 */
function currentTenant(): string {
  return config.tenant;
}

/**
 * Get the currently active host based on the URL
 */
function currentHost(): string {
  return window.location.host.split('.')[1];
}

/**
 * Scroll the element into view without moving the rest of the page
 */
function scrollElementIntoView(
  element: HTMLElement,
  orientation: ScrollIntoViewOptions["block"] = 'center',
  behavior?: ScrollIntoViewOptions["behavior"]
) {
  if (!element) {
    return;
  }
  const {scrollTop} = document.documentElement;
  element.scrollIntoView({block: orientation, behavior});
  document.documentElement.scrollTop = scrollTop;
}

export {
  currentTenant,
  currentHost,
  scrollElementIntoView
};
